export default "/assets/images/mila-insights.png?bb9f72b9a85ec33d8de54095e3de5bf4";